class Page {
  get controller() {
    return document.querySelector('meta[name=psj]').getAttribute('controller');
  }

  get action() {
    return document.querySelector('meta[name=psj]').getAttribute('action');
  }

  get isLoggedIn() {
    return document.querySelector('meta[name=psj]').getAttribute('signed_in') === 'true';
  }
}

const page = new Page();

export default page;
